export default __webpack_public_path__ + "static/media/8.65d4f094.png";